import { useQuery } from '@tanstack/react-query';
import { getOverview } from '@/lib/api';
import { OVERVIEW_QUERY_KEY } from '@/lib/query-keys';

export { OVERVIEW_QUERY_KEY } from '@/lib/query-keys';

/**
 * How often the overview re-reads itself, so the sidebar and landing view keep up
 * without a reload.
 *
 * @since 1.3.0
 */
export const OVERVIEW_REFETCH_MS = 60_000;

/**
 * Options a caller may set on the overview query.
 *
 * @since 1.3.0
 */
export interface UseOverviewOptions {
    throwOnError?: boolean;
}

/**
 * Reads the overview payload and keeps it fresh on an interval.
 *
 * @since 1.0.0
 * @param options - whether a failure should throw to the page boundary
 * @returns the overview query result
 */
export function useOverview(options: UseOverviewOptions = {}) {
    return useQuery({
        queryKey: OVERVIEW_QUERY_KEY,
        queryFn: getOverview,
        refetchInterval: OVERVIEW_REFETCH_MS,
        throwOnError: options.throwOnError ?? true,
    });
}
